const SovMap = () => import(/* webpackChunkName: "SovMap" */ '../views/SovMap')

const sovRouter = [
    {
      path: '/sov-map',
      name: 'sovdmap',
      component: SovMap,
      meta: { isLinkAja: true }
    }
]

export default sovRouter;
